import { MailsService } from "../../services/mails/MailsService";
import { CreateMailsTaskInfo } from "../../../api/typings/Mails";
import { uiStore } from "../UiStore/UiStore";
import { MailsTasksStatusEnum } from "../../../static/enums/MailsTasksStatusEnum";

class MailsStore {
  protected mailsService: MailsService;

  constructor() {
    this.mailsService = new MailsService();
  }

  createMailTask = async (data: CreateMailsTaskInfo) => {
    try {
      uiStore.startPending();
      const response = await this.mailsService.createMailTask(data);
      setTimeout(() => {
        this.getMailTaskWithTimeout(response.data!.id);
      }, 0);
    } catch (e) {
      uiStore.notify({
        message: "Не удалось отправить письмо!",
        options: {
          variant: "error",
        },
      });
    } finally {
      uiStore.stopPending();
    }
  };

  getMailTaskWithTimeout = async (id: string) => {
    try {
      const response = await this.mailsService.getMailTask(id);
      switch (response.data!.attributes!.status) {
        case MailsTasksStatusEnum.processed:
          setTimeout(this.getMailTaskWithTimeout, 1000, id);
          break;
        case MailsTasksStatusEnum.created:
          uiStore.notify({
            message: "Письмо успешно отправлено!",
            options: {
              variant: "success",
            },
          });
          break;
        case MailsTasksStatusEnum.failed:
          uiStore.notify({
            message: "Не удалось отправить письмо!",
            options: {
              variant: "error",
            },
          });
          break;
      }
    } catch (e) {
      uiStore.notify({
        message: "Не удалось отправить письмо!",
        options: {
          variant: "error",
        },
      });
    }
  };
}

export const mailsStore = new MailsStore();
